import { cn } from '@/_lib/utils'

const ZHomeSectionLayoutTitle = ({ className, title }: { className?: string; title: string }) => {
	return (
		<h2
			className={cn('text-3xl md:text-4xl lg:font-light', className)}
			dangerouslySetInnerHTML={{ __html: title }}
		/>
	)
}

const ZHomeSectionLayoutDescription = ({
	className,
	description,
	button
}: {
	className?: string
	description?: string
	button?: React.ReactNode
}) => {
	return (
		<div>
			{description && (
				<p
					className={cn('text-base', className)}
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			)}
			{button && <div className='mt-4'>{button}</div>}
		</div>
	)
}

const ZHomeSectionLayout = ({
	children,
	className,
	title,
	description,
	id
}: {
	children: React.ReactNode
	className?: string
	title: React.ReactNode
	description?: React.ReactNode
	id?: string
}) => {
	return (
		<div className={cn('pt-12 lg:pt-20 pb-10 lg:pb-20', className)} id={id}>
			<div className='max-w-section px-4 mx-auto'>
				<div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 lg:mb-12'>
					<div>{title}</div>

					{description || (description && <div>{description}</div>)}
				</div>

				{children}
			</div>
		</div>
	)
}

export default ZHomeSectionLayout
export { ZHomeSectionLayoutTitle, ZHomeSectionLayoutDescription }
